<template>
    <div class="PwSearchResultSend">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>비밀번호 찾기</h2>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <template>
                <div class="padding-50">
                    <img src="@/assets/images/find_search_result.png" width="100%" />
                </div>
                <p class="info-msg mrg-btm-40"
                    v-if="resultType == 'phone'">
                    선택하신 휴대폰번호로 임시 비밀번호를 전송하였습니다.
                </p>
                <p class="info-msg mrg-btm-40"
                   v-else>
                    선택하신 이메일로 임시 비밀번호를 전송하였습니다.
                </p>
                <button class="btn-big btn-bule"
                        @click.prevent="loginMoveFunc">
                    로그인 하기
                </button>
            </template>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'PwSearchResultSend',
    props: ['pResultType'],
    data() {
        return {
            resultType:'',  // 임시비밀번호 보낸 방법(휴대폰, 이메일)
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.resultType = this.pResultType;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.loginMoveFunc();
        },
        // 로그인 화면 이동
        loginMoveFunc(){
            let param = {};
            param.result = 'close';

            this.slidePanelClose(param);
        }
    }
}
</script>

<style scoped>
</style>
